<div class="dialog-header">
  <h3>Detalle de amortización</h3>

  <button
    class="close-button"
    aria-label="Cerrar" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <table mat-table [dataSource]="dataSource" class="tabla-detalle">

    <ng-container matColumnDef="numeroCuota">
      <th mat-header-cell *matHeaderCellDef>N°</th>
      <td mat-cell *matCellDef="let r">{{ r.numeroCuota }}</td>
    </ng-container>

    <ng-container matColumnDef="capital">
      <th mat-header-cell *matHeaderCellDef>Capital</th>
      <td mat-cell *matCellDef="let r">
        {{ r.capital | currency:'$':'symbol':'1.0-0' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="interes">
      <th mat-header-cell *matHeaderCellDef>Interés</th>
      <td mat-cell *matCellDef="let r">
        {{ r.interes | currency:'$':'symbol':'1.0-0' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="seguro">
      <th mat-header-cell *matHeaderCellDef>Seguro</th>
      <td mat-cell *matCellDef="let r">
        {{ r.seguro | currency:'$':'symbol':'1.0-0' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="valorCuota">
      <th mat-header-cell *matHeaderCellDef>Valor cuota</th>
      <td mat-cell *matCellDef="let r">
        {{ r.valorCuota | currency:'$':'symbol':'1.0-0' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="saldoCapital">
      <th mat-header-cell *matHeaderCellDef>Saldo</th>
      <td mat-cell *matCellDef="let r">
        {{ r.saldoCapital | currency:'$':'symbol':'1.0-0' }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</mat-dialog-content>